<template>
  <div class="side-frame-success">
    <span style="font-size: 14px; color: #606266">{{
      this.$l('INDEX.table_label_custName') || '客户'
    }}</span>
  </div>
</template>
<script>
// 初始表单

export default {
  props: {},
  data() {
    return {}
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query')
    },
  },
}
</script>
